module.exports = __webpack_public_path__ + "static/media/feeback-profile.bf74c1af.svg";